import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import { Numeric, DecimalValidation, Text } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPAlert from "framework/widgets/DPAlert"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import moment from "moment"
import ReactPaginate from "react-paginate"

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const ProductPriceContent = ({ DataRow, setarRowPrice, Disabled, menuCode, handleClearStatus, locationPriceForm, setLocationPriceForm }) => {

  const date = new Date()
  const today = moment(date).format("YYYY-MM-DD")

  const [postsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)




  /*
  * @description This function is used to reset the page number to 1 when the clear button is clicked.
  */
  useEffect(() => {
    setCurrentPage(1)
  }, [handleClearStatus])

  /**
      * @description This function is used to change the value of perticular field in perticular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRowPrice(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
      * @description This function is used to change the value of complete row.
      * @param {JSON} row - row of the table.
      * @param {string} id - id of the row.
   */



  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRowPrice(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }


  /**
  * @description This function is used to add new row in the table.
 */
  function handleAddRowNestedPrice() {

    // Check if there is any existing row with empty values
    const hasEmptyRow = DataRow.find(x => x.code == "");


    if (hasEmptyRow) {
      // If there is any row with empty values, do not add a new row
      return false;
    }

    const modifiedRows = [...DataRow]
    modifiedRows.push({
      id: modifiedRows.length + 1,
      Loccode: "",
      code: "",
      desc: "",
      locCodeDisable: false,
      StartDate: today,
      EndDate: today,
      StartQty: 0,
      EndQty: 0,
      DiscountPer: 0,
      DiscountAmt: 0,
      FixedPrice: 0,
      state: true,
      priceCodeDisable: true,
      supContribute: 0,
      comContribute: 0
    })

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRowPrice(idModification)
  }


  /**
  * @description This function is used to add new row in the table.
 */

  function handleRemoveRowprice(id) {
    const modifiedRows = [...DataRow]
    const index = modifiedRows.findIndex(x => x.id === id)
    modifiedRows.splice(index, 1)

    if (modifiedRows.length === 0) {
      modifiedRows.push({
        id: 1,
        Loccode: "",
        code: "",
        desc: "",
        locCodeDisable: false,
        StartDate: today,
        EndDate: today,
        StartQty: 0,
        EndQty: 0,
        DiscountPer: 0,
        DiscountAmt: 0,
        FixedPrice: 0,
        state: true,
        priceCodeDisable: true,
        supContribute: 0,
        comContribute: 0
      })
    }

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRowPrice(idModification)
  }


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  const filteredTable = DataRow.filter((value) => {
    return value[locationPriceForm.searchBy].toLowerCase().includes(String(locationPriceForm.searchPram).toLowerCase())
  })

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = filteredTable.slice(indexOfFirstPost, indexOfLastPost)


  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <input id="SearchBar"
            type="text"
            className="form-control"
            aria-label="Username"
            aria-describedby="basic-addon1"
            style={{ height: '28px', width: '300px' }}
            maxLength={30}
            value={locationPriceForm.searchPram}
            placeholder={locationPriceForm.placeHolder}
            onChange={e => {
              setLocationPriceForm({ ...locationPriceForm, searchPram: e.target.value })
              setCurrentPage(1)
            }} />
          <table style={{ fontSize: "11px" }} id={"PriceDet"}>
            <thead className="table-light">
              <tr>
                <th style={{ cursor: "pointer" }}
                  onClick={() => {
                    setLocationPriceForm({
                      searchPram: "",
                      searchBy: "Loccode",
                      placeHolder: "Search by Location code",
                    })
                    setCurrentPage(1)
                  }}>Location Code </th>
                <th></th>
                <th>Location Name</th>
                <th style={{ cursor: "pointer" }}
                  onClick={() => {
                    setLocationPriceForm({
                      searchPram: "",
                      searchBy: "code",
                      placeHolder: "Search by Price Mode code",
                    })
                    setCurrentPage(1)
                  }}>Price mode </th>
                <th></th>
                <th style={{ cursor: "pointer" }}
                  onClick={() => {
                    setLocationPriceForm({
                      searchPram: "",
                      searchBy: "desc",
                      placeHolder: "Search by Price Mode Description",
                    })
                    setCurrentPage(1)
                  }}>Description </th>
                <th>Starting Date </th>
                <th>Ending Date </th>
                <th>Starting quantity </th>
                <th>Ending quantity </th>
                <th>Discount(%) </th>
                <th>Discount Amount </th>
                <th>Fixed Price </th>
                <th>Company Contribution</th>
                <th>Supplier Contribution</th>
                <th style={{ textAlign: "center" }}>Is Active</th>
              </tr>
            </thead>
            <tbody disabled={true}>
              {(currentPosts).map((formRow, key) => (
                <TableRow FormRow={formRow}
                  Key={key}
                  RemoveRow={handleRemoveRowprice}
                  DataRow={DataRow}
                  Disabled={Disabled}
                  menuCode={menuCode}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                />
              ))}
            </tbody>
          </table>
          <Button
            onClick={() => {
              handleAddRowNestedPrice()
            }}
            disabled={Disabled}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataRow.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-center pagination-sm'}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default ProductPriceContent

const TableRow = ({ DataRow, FormRow, Key, RemoveRow, Disabled, menuCode, changeRowValueChanges, handleObjectChange }) => {

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlarge1, setmodal_xlarge1] = useState(false)


  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]



  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    const locationCode = FormRow.Loccode;
    const priceModeCode = row.PRM_CODE;


    // Check if the combination of location code and price mode code already exists
    const isDuplicate = DataRow.some(item => item.Loccode == locationCode && item.code == priceModeCode);

    if (isDuplicate) {
      setAlertDescription(`Combination of location code ${locationCode} and price mode code ${priceModeCode} already exists!`);
      setAlertConfirmOption(4);
      setsweetAlertShow(true);

    } else {
      // Update the state or perform other actions
      var currentRow = FormRow;
      currentRow.code = row.PRM_CODE;
      currentRow.desc = row.PRM_DESC;
      currentRow.priceCodeDisable = true;
      handleObjectChange(currentRow, FormRow.id);
    }

    setmodal_xlarge1(!modal_xlarge1);
  };


  /**
    * @description This function is used to handle the change of the input fields
    * Location code search row selection event handler
   */

  const Hed_SelectRowSearchLoc = (e, row, isSelect, rowIndex) => {
    if (LocationCodeValidation(row.LOC_CODE, 1)) {

      LocCodeSearch(row.LOC_CODE)
      // var currentRow = FormRow
      // currentRow.Loccode = row.LOC_CODE
      // currentRow.locCodeDisable = true;
      // handleObjectChange(currentRow, FormRow.id)
    } else {
      setAlertDescription("Location code already used!")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)

    }
    //setmodal_xlarge(!modal_xlarge)
    setmodal_xlarge(!modal_xlarge)
  }


  /**
   * Location code search function 
   * @param {string} value
   */

  function LocCodeSearch(value) {
    if (value == "") return

    var currentRow = FormRow

    fetch(`${ApiURL}Locations/SearchCode/${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const newArray = responseData.data[0]
          currentRow.Loccode = newArray.code
          currentRow.LocName = newArray.name
          currentRow.locCodeDisable = true;
          currentRow.priceCodeDisable = false;
          handleObjectChange(currentRow, FormRow.id)
        }
        else {

          currentRow.Loccode = ""
          handleObjectChange(currentRow, FormRow.id)


        }
      }).catch((error) => {
        console.log(error)
        currentRow.Loccode = ""
        handleObjectChange(currentRow, FormRow.id)
      })
  }

  function CheckValid(value) {
    if (FormRow.StartDate >= value) {
      changeRowValueChanges(Date, FormRow.id, "StartDate")
    }
  }

  function CheckValidStart(value) {
    if (value >= FormRow.EndDate) {
      changeRowValueChanges(Date, FormRow.id, "EndDate")
    }
  }


  function CheckStartQty(value) {
    if (FormRow.EndQty != "0.0") {
      if (parseFloat(value, 10) >= parseFloat(FormRow.EndQty, 10)) {
        changeRowValueChanges(0, FormRow.id, "StartQty")
      }
    }
  }


  function CheckEndQty(value) {
    if (parseFloat(value, 10) < parseFloat(FormRow.StartQty, 10)) {
      changeRowValueChanges(0, FormRow.id, "EndQty")
    }
  }


  /**
    * Price code search function
    * @param {string} value
   */

  function PriceCodeSearch(value) {
    var currentRow = FormRow
    if (value == "") {
      currentRow.code = ""
      currentRow.desc = ""
      // currentRow.locCodeDisable = true;
      // currentRow.priceCodeDisable = true;
      handleObjectChange(currentRow, FormRow.id)
      return
    }

    const ApiURL = window.Links.ApiURL
    fetch(`${ApiURL}PriceMode/search/${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {

          const newArray = responseData.data[0]
          currentRow.code = newArray.code
          currentRow.desc = newArray.name
          currentRow.locCodeDisable = true;
          currentRow.priceCodeDisable = true;
          handleObjectChange(currentRow, FormRow.id)

        } else {
          currentRow.code = ""
          currentRow.desc = ""
          handleObjectChange(currentRow, FormRow.id)
        }
      })

  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  function tog_xlargeNew() {
    setmodal_xlarge1(!modal_xlarge1)
    removeBodyCss()
  }

  async function clickSearch() {
    tog_xlarge()
  }
  async function clickPriceSearch() {
    tog_xlargeNew()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  //Price mode validation stop duplicate code
  const CodeValidation = (strCode, onclick = 0) => {

    //check save strcode is already exist with same location code
    var filterBycode = DataRow.filter((item) => item.code == strCode && item.Loccode == FormRow.Loccode)

    if (onclick == 1) {
      if (filterBycode.length > 0) {
        return false
      }
    } else {
      if (filterBycode.length > 1) {
        return false
      }
    }
    return true
  }


  const LocationCodeValidation = (strCode, priceMode, onclick = 0) => {
    var filterBycodeAndMode = DataRow.filter((item) => item.Loccode == strCode && item.PriceMode == priceMode && item.id != FormRow.id);

    if (onclick == 1) {
      if (filterBycodeAndMode.length > 0) {
        return false;
      }
    } else {
      if (filterBycodeAndMode.length > 1) {
        return false;
      }
    }

    return true;
  };



  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "140px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtLoccode" + Key}
              value={FormRow.Loccode}
              onChange={e => {

                let valLocation = Text(
                  e.target,
                  10,
                  false,
                  false,
                  "any",
                  false
                )

                changeRowValueChanges(valLocation, FormRow.id, "Loccode")
              }}
              onBlur={e => {
                if (LocationCodeValidation(e.target.value, 0)) {
                  LocCodeSearch(e.target.value);
                } else {
                  setAlertDescription("Location code already used!")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                  changeRowValueChanges("", FormRow.id, "Loccode")
                }
              }}
              disabled={Disabled ? true : FormRow.locCodeDisable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              disabled={Disabled ? true : FormRow.locCodeDisable}
              color="success"
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "160px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              disabled={true}
              id={"LocName" + Key}
              value={FormRow?.LocName ?? ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "140px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtcode" + Key}
              value={FormRow.code}
              onChange={e => {
                // setcode(e.target.value)
                changeRowValueChanges(e.target.value, FormRow.id, "code")
              }}
              onBlur={e => {
                if (CodeValidation(e.target.value, 0)) {
                  PriceCodeSearch(e.target.value)
                }
                else {
                  setAlertDescription(`Combination of location code ${FormRow.Loccode} and price mode code ${e.target.value} already exists!`)
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                  changeRowValueChanges("", FormRow.id, "code")
                }

              }}
              disabled={Disabled ? true : FormRow.priceCodeDisable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline

              disabled={Disabled ? true : FormRow.priceCodeDisable}
              color="success"
              id={"btnSearch" + Key}
              onClick={clickPriceSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "160px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              disabled={true}
              id={"txtPriceDesc" + Key}
              value={FormRow.desc}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="Date"
              maxLength="30"
              width="110px"
              id={"txtStartDate" + Key}
              value={FormRow.StartDate}
              onChange={e => {

                changeRowValueChanges(e.target.value, FormRow.id, "StartDate")
                CheckValidStart(e.target.value)

              }}
              disabled={Disabled}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="Date"
              maxLength="30"
              width="110px"
              id={"txtEndDate" + Key}
              value={FormRow.EndDate}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "EndDate")
                CheckValid(e.target.value)
              }}
              disabled={Disabled}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "75px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              defaultValue="0.0"
              textAlign="right"
              id={"txtStartQty" + Key}
              value={FormRow.StartQty}
              onChange={e => {

                let StartQty = Numeric(e.target, 8, 2, false)
                if (StartQty == "") {
                  // setStartQty("0.0")
                  changeRowValueChanges("0.0", FormRow.id, "StartQty")
                }
                else {
                  changeRowValueChanges(StartQty, FormRow.id, "StartQty")
                }
              }}
              onBlur={e => {
                let StartQty = DecimalValidation(e.target.value, 0, true, 2)
                if (StartQty == "") {
                  changeRowValueChanges("0.0", FormRow.id, "StartQty")
                }
                else {
                  changeRowValueChanges(parseFloat(StartQty, 10), FormRow.id, "StartQty")
                  CheckStartQty(e.target.value)
                }
              }}
              disabled={Disabled}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "75px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled}
              defaultValue="0.0"
              textAlign="right"
              id={"txtEndQty" + Key}
              value={FormRow.EndQty}
              onChange={e => {
                let EndQty = Numeric(e.target, 8, 2, false)
                if (EndQty == "") {
                  changeRowValueChanges("0.0", FormRow.id, "EndQty")
                }
                else {
                  changeRowValueChanges(EndQty, FormRow.id, "EndQty")
                }

              }}
              onBlur={e => {
                let EndQty = DecimalValidation(e.target.value, 0, true, 2)
                if (EndQty == "") {
                  changeRowValueChanges("0.0", FormRow.id, "EndQty")
                }
                else {
                  changeRowValueChanges(parseFloat(EndQty, 10), FormRow.id, "EndQty")
                  CheckEndQty(e.target.value)
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled}
              defaultValue="0.0"
              textAlign="right"
              id={"txtDiscountPer" + Key}
              value={FormRow.DiscountPer}
              onChange={e => {
                let DiscountPer = Numeric(e.target, 8, 2, true)
                if (DiscountPer == "") {
                  changeRowValueChanges("0.0", FormRow.id, "DiscountPer")
                }
                else {
                  changeRowValueChanges(DiscountPer, FormRow.id, "DiscountPer")
                }
              }}
              onBlur={e => {
                let DiscountPer = DecimalValidation(e.target.value)
                if (DiscountPer == "") {
                  changeRowValueChanges("0.0", FormRow.id, "DiscountPer")
                }
                else {
                  DiscountPer = parseFloat(DiscountPer, 10);
                  // Check if the entered value is greater than 100%
                  if (DiscountPer > 100) {
                    changeRowValueChanges("0.0", FormRow.id, "DiscountPer");
                  } else if (DiscountPer < -100) {
                    changeRowValueChanges("0.0", FormRow.id, "DiscountPer");
                  } else {
                    changeRowValueChanges(DiscountPer, FormRow.id, "DiscountPer");

                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              defaultValue="0.0"
              textAlign="right"
              id={"txtDiscountAmt" + Key}
              value={FormRow.DiscountAmt}
              onChange={e => {
                let DiscountAmt = Numeric(e.target, 8, 2, true)
                if (DiscountAmt == "") {
                  changeRowValueChanges("0.0", FormRow.id, "DiscountAmt")
                }
                else {
                  changeRowValueChanges(DiscountAmt, FormRow.id, "DiscountAmt")
                }

              }}
              onBlur={e => {
                let DiscountAmt = DecimalValidation(e.target.value, 0, true, 2)
                if (DiscountAmt == "") {
                  changeRowValueChanges("0.0", FormRow.id, "DiscountAmt")
                }
                else {
                  changeRowValueChanges(DecimalValidation(DiscountAmt, 0, true, 2), FormRow.id, "DiscountAmt")
                }
              }}
              disabled={Disabled ? true : parseFloat(FormRow.FixedPrice) > 0 ? true : false}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled ? true : parseFloat(FormRow.DiscountAmt) > 0 ? true : false}
              defaultValue="0.0"
              textAlign="right"
              id={"txtFixedPrice" + Key}
              value={FormRow.FixedPrice}
              onChange={e => {
                let FixedPrice = Numeric(e.target, 8, 2, false)
                if (FixedPrice == "") {
                  changeRowValueChanges("0.0", FormRow.id, "FixedPrice")
                }
                else {
                  changeRowValueChanges(FixedPrice, FormRow.id, "FixedPrice")
                }
              }}
              onBlur={e => {
                let FixedPrice = DecimalValidation(e.target.value, 0, true, 2)
                if (FixedPrice == "") {
                  changeRowValueChanges("0.0", FormRow.id, "FixedPrice")
                }
                else {
                  changeRowValueChanges(DecimalValidation(FixedPrice, 0, true, 2), FormRow.id, "FixedPrice")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled}
              defaultValue="0.0"
              textAlign="right"
              id={"comContribute" + Key}
              value={FormRow.comContribute}
              onChange={e => {
                let comContribute = Numeric(e.target, 8, 2, false)
                changeRowValueChanges(comContribute, FormRow.id, "comContribute")
              }}
              onBlur={e => {
                let comContribute = DecimalValidation(e.target.value, 0, true, 2)
                if (comContribute > 100) {
                  changeRowValueChanges("0.0", FormRow.id, "comContribute")
                } else {
                  changeRowValueChanges(comContribute, FormRow.id, "comContribute")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled}
              defaultValue="0.0"
              textAlign="right"
              id={"supContribute" + Key}
              value={FormRow.supContribute}
              onChange={e => {
                let supContribute = Numeric(e.target, 8, 2, false)
                changeRowValueChanges(supContribute, FormRow.id, "supContribute")
              }}
              onBlur={e => {
                let supContribute = DecimalValidation(e.target.value, 0, true, 2)

                if (supContribute > 100) {
                  changeRowValueChanges("0.0", FormRow.id, "supContribute")
                } else {
                  changeRowValueChanges(supContribute, FormRow.id, "supContribute")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "70px", margin: "auto", textAlign: "center" }}>
        <Row className="mb-0">
          <Col md="12">
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              onChange={(e) => {
                // SetState(!state)
                changeRowValueChanges(e, FormRow.id, "state")
              }}
              checked={FormRow.state}
              id={"swActive" + Key}
              disabled={Disabled}
            />
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              disabled={Disabled}
              color="danger"
              id={"btnDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm"
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}

          <DPSearchBoxDynamic
            searchData={[]}
            columns={[]}
            defaultSorted={defaultSorted}
            mainTitle={"Location Search"}
            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearchLoc}
            APIURL={ApiURL}
            URLPath={"LOCATION"}
            MenuCode={menuCode}
            KeyVal={'LOC'}
            searchBy={'LOC_CODE'}
            FilterStr={'a'}
          />

          <DPSearchBoxDynamic
            searchData={[]}
            columns={[]}
            defaultSorted={defaultSorted}
            mainTitle={"Price Mode Detail Search"}
            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge1}
            toggle={tog_xlargeNew}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"PRICEMOD"}
            MenuCode={menuCode}
            KeyVal={'PMOD'}
            searchBy={'PRM_CODE'}
            FilterStr={'a'}
          />

          <DPAlert
            confirm_both={sweetAlertShow}
            title={"Product Master !"}
            description={AlertDescription}
            showCancel={false}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
            }}
            btnYes={"OK"}
          />
        </Row>
      </td>
    </tr>
  )
}
